import { useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { ImageIcon, X } from 'lucide-react'

import type { PickedImage } from '@/components/retail/cms/post-form-model'
import { MediaPicker } from '@/components/media'
import { Button } from '@/components/ui/button'
import { FieldError } from '@/components/ui/field'
import { Label } from '@/components/ui/label'
import { m } from '@/lib/paraglide/messages'

/** Ô ảnh chọn từ thư viện (ảnh bìa, ảnh chia sẻ): giữ {id, url} trong form. */
export function ContentMediaField({
    name,
    label,
    hint,
}: {
    name: string
    label: string
    hint?: string
}) {
    const { control } = useFormContext()
    const [open, setOpen] = useState(false)
    return (
        <div className="space-y-1.5">
            <Label htmlFor={name}>{label}</Label>
            <Controller
                control={control}
                name={name}
                render={({ field }) => {
                    const img = field.value as PickedImage | null
                    return (
                        <div className="flex items-center gap-3">
                            {img ? (
                                <img
                                    src={img.thumb_url || img.url}
                                    alt={img.alt ?? ''}
                                    className="size-20 rounded-md border object-cover"
                                />
                            ) : (
                                <span className="flex size-20 items-center justify-center rounded-md border border-dashed text-muted-foreground">
                                    <ImageIcon className="size-6" aria-hidden />
                                </span>
                            )}
                            <div className="flex flex-col gap-2">
                                <Button
                                    id={name}
                                    type="button"
                                    variant="outline"
                                    size="sm"
                                    onClick={() => setOpen(true)}
                                >
                                    {img
                                        ? m.cmsPost_media_change()
                                        : m.cmsPost_media_pick()}
                                </Button>
                                {img && (
                                    <Button
                                        type="button"
                                        variant="ghost"
                                        size="sm"
                                        onClick={() => field.onChange(null)}
                                    >
                                        <X className="size-4" />
                                        {m.cmsPost_media_remove()}
                                    </Button>
                                )}
                            </div>
                            <MediaPicker
                                open={open}
                                onOpenChange={setOpen}
                                kind="image"
                                title={label}
                                onSelect={(items) => {
                                    const it = items[0]
                                    if (it)
                                        field.onChange({
                                            id: it.id,
                                            url: it.url,
                                            alt: it.alt,
                                        })
                                }}
                            />
                        </div>
                    )
                }}
            />
            {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
            <FieldError name={name} />
        </div>
    )
}
